import { render, staticRenderFns } from "./PanelTodayPopular.vue?vue&type=template&id=5c7b94a6&scoped=true"
import script from "./PanelTodayPopular.vue?vue&type=script&lang=js"
export * from "./PanelTodayPopular.vue?vue&type=script&lang=js"
import style0 from "./PanelTodayPopular.vue?vue&type=style&index=0&id=5c7b94a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b94a6",
  null
  
)

export default component.exports